module.exports = __webpack_public_path__ + "img/0005.5e24d8be.png";